import changelogJson from '@/changelog.json'
import { listed, type Entry } from '@/lib/whats-new'

/** src/changelog.json, newest release first. The release check in `npm run deploy:app` keeps it current. */
export const CHANGELOG = changelogJson as Entry[]

/** The releases Settings → What's new lists: one that is all hidden has nothing to say. */
export const LISTED = listed(CHANGELOG)
